import {
  TIMELINES_MILESTONE_SHAPES,
  TIMELINE_MILESTONE_SIZE,
  TIMELINE_MILESTONE_MARGIN,
} from './../consts';
import styled from 'styled-components';
import { Icon, IconSize } from '@ardoq/icons';
import { MilestonesWithRenderingParameters } from '../../types';
import { POPOVER_ELEMENT_TYPE } from '../../consts';

const MilestoneContainer = styled.div`
  margin: 0;
  position: absolute;
  z-index: 3;
  width: ${TIMELINE_MILESTONE_SIZE}px;
  top: ${TIMELINE_MILESTONE_MARGIN}px;
  height: ${TIMELINE_MILESTONE_SIZE}px;
`;

type MilestoneArgs = {
  milestone: MilestonesWithRenderingParameters;
  graphNodeId: string;
  phasesRowIndex: number;
};

export const getMilestoneShapeForFieldIndex = (milestoneFieldIndex: number) =>
  TIMELINES_MILESTONE_SHAPES[
    milestoneFieldIndex % TIMELINES_MILESTONE_SHAPES.length
  ];

export const getMilestoneShape = (
  milestoneFieldIndex: number,
  size = IconSize.MEDIUM
) => {
  const shape = (
    <Icon
      iconName={getMilestoneShapeForFieldIndex(milestoneFieldIndex)}
      iconSize={size}
      data-milestone-index={milestoneFieldIndex}
    />
  );
  return shape;
};

export const Milestone = ({
  milestone,
  graphNodeId,
  phasesRowIndex,
}: MilestoneArgs) => (
  <MilestoneContainer
    style={{
      left: milestone.scaledStart,
    }}
    data-graph-node-id={graphNodeId}
    data-phases-row-index={phasesRowIndex}
    data-popover-element-type={POPOVER_ELEMENT_TYPE.MILESTONE}
  >
    {getMilestoneShape(milestone.fieldIndex, TIMELINE_MILESTONE_SIZE)}
  </MilestoneContainer>
);
